package diana.soleil.design.iraniancanadienbazzar.feature.business

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.asPaddingValues
import androidx.compose.foundation.layout.navigationBars
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.foundation.horizontalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.text.style.TextAlign
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButtonVariant
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppBottomSheet
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppChip
import diana.soleil.design.iraniancanadienbazzar.core.model.BusinessAttributeRegistry
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIcon
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIconButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppSearchBar
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.BusinessCover
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.DirectoryBusinessCard
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ErrorState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.LoadingState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.categoryImageRes
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.appContentWidth
import diana.soleil.design.iraniancanadienbazzar.core.data.LocationController
import diana.soleil.design.iraniancanadienbazzar.core.model.Business
import diana.soleil.design.iraniancanadienbazzar.core.model.Category
import diana.soleil.design.iraniancanadienbazzar.core.model.categoryIconKey
import diana.soleil.design.iraniancanadienbazzar.core.model.cityLabel
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.Res
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_action_details
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_action_view_menu
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_call_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_directions_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_badge_new
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_error
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_favorite_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_retry
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_verified
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_pro_badge
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_sponsored
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.business_verified_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_recent_title
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_recent_clear
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_ask_community
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_browse_categories
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_apply
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_back_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_clear_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_empty_no_results
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_filter_sponsored
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_filter_verified
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_filter_amenities
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_filters_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_placeholder
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_rating_3
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_rating_4
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_rating_any
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_rating_label
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_reset
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_result_count
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_sheet_title
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_sort_label
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_sort_most_reviewed
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_sort_nearest
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_sort_name
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_sort_recommended
import diana.soleil.design.iraniancanadienbazzar.feature.business.resources.search_sort_top_rated
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.koinInject
import org.koin.compose.viewmodel.koinViewModel

/** Stateful entry for directory search: resolves [SearchViewModel] and renders the stateless screen. */
@Composable
fun SearchRoute(
    onBack: () -> Unit,
    onBusinessClick: (businessId: String) -> Unit,
    modifier: Modifier = Modifier,
    onCategoryClick: (categoryId: String) -> Unit = {},
    onAskCommunity: () -> Unit = {},
    /** Pre-fills the query once on entry (e.g. a recipe's "find ingredients" deep link). */
    initialQuery: String? = null,
    viewModel: SearchViewModel = koinViewModel(),
    locationController: LocationController = koinInject(),
) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    // Feeds the "Nearest" sort + nearby ranking (once per session; metro centre when denied).
    LaunchedEffect(Unit) { locationController.ensureLocation() }
    // One-shot prefill: seeds the field + results; the user can clear/edit it freely afterwards.
    LaunchedEffect(initialQuery) {
        if (!initialQuery.isNullOrBlank()) viewModel.onQueryChange(initialQuery)
    }
    SearchScreen(
        state = state,
        onQueryChange = viewModel::onQueryChange,
        onApplyFilters = viewModel::onFiltersChange,
        onResetFilters = viewModel::clearFilters,
        onToggleFavorite = viewModel::toggleFavorite,
        onClearRecents = viewModel::clearRecentSearches,
        onCategoryClick = onCategoryClick,
        onAskCommunity = onAskCommunity,
        onBack = onBack,
        onBusinessClick = { id ->
            viewModel.trackResultClick(id)
            onBusinessClick(id)
        },
        modifier = modifier,
    )
}

/**
 * Directory search — Phase 1 "basic search/filter/sort" (`docs/ROADMAP.md`). No standalone Stitch
 * screen; reuses the directory card + the app bottom sheet. Stateless; driven by [SearchUiState].
 */
@Composable
fun SearchScreen(
    state: SearchUiState,
    onQueryChange: (String) -> Unit,
    onApplyFilters: (SearchFilters) -> Unit,
    onResetFilters: () -> Unit,
    onToggleFavorite: (String) -> Unit,
    onBack: () -> Unit,
    onBusinessClick: (businessId: String) -> Unit,
    modifier: Modifier = Modifier,
    onClearRecents: () -> Unit = {},
    onCategoryClick: (categoryId: String) -> Unit = {},
    onAskCommunity: () -> Unit = {},
) {
    var showFilters by remember { mutableStateOf(false) }
    val focusRequester = remember { FocusRequester() }

    Column(modifier = modifier.fillMaxSize().background(AppTheme.colors.background)) {
        // Search bar row: back + input + filter button
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .statusBarsPadding()
                .padding(horizontal = AppTheme.spacing.lg, vertical = AppTheme.spacing.md),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        ) {
            AppIconButton(
                iconName = "arrow_back",
                contentDescription = stringResource(Res.string.search_back_a11y),
                onClick = onBack,
                tint = AppTheme.colors.onSurface,
            )
            AppSearchBar(
                value = state.query,
                onValueChange = onQueryChange,
                placeholder = stringResource(Res.string.search_placeholder),
                modifier = Modifier.weight(1f).focusRequester(focusRequester),
                leading = { AppIcon("search", tint = AppTheme.colors.onSurfaceVariant) },
                trailing = if (state.query.isNotEmpty()) {
                    {
                        AppIconButton(
                            iconName = "close",
                            contentDescription = stringResource(Res.string.search_clear_a11y),
                            onClick = { onQueryChange("") },
                            tint = AppTheme.colors.onSurfaceVariant,
                        )
                    }
                } else null,
            )
            FilterButton(
                activeCount = state.filters.activeCount,
                onClick = { showFilters = true },
            )
        }

        when {
            state.loading -> LoadingState()
            state.error -> ErrorState(
                message = stringResource(Res.string.business_error),
                onRetry = { onQueryChange(state.query) },
                retryLabel = stringResource(Res.string.business_retry),
            )
            !state.hasQueryOrFilter -> PreTypingContent(
                recentSearches = state.recentSearches,
                categories = state.categories,
                onRecentClick = onQueryChange,
                onClearRecents = onClearRecents,
                onCategoryClick = onCategoryClick,
            )
            state.results.isEmpty() -> Column(
                modifier = Modifier.fillMaxSize().padding(AppTheme.spacing.xxl),
                verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg, Alignment.CenterVertically),
                horizontalAlignment = Alignment.CenterHorizontally,
            ) {
                Text(
                    text = stringResource(Res.string.search_empty_no_results),
                    style = AppTheme.typography.bodyMd,
                    color = AppTheme.colors.onSurfaceVariant,
                    textAlign = TextAlign.Center,
                )
                // "Ask the Mahaleh": no result is a question waiting to be asked.
                AppButton(
                    text = stringResource(Res.string.search_ask_community),
                    onClick = onAskCommunity,
                    variant = AppButtonVariant.Secondary,
                    leadingIcon = "forum",
                )
            }
            else -> LazyColumn(
                modifier = Modifier.appContentWidth(AppTheme.sizes.contentMaxWidth),
                contentPadding = PaddingValues(
                    start = AppTheme.spacing.lg,
                    end = AppTheme.spacing.lg,
                    top = AppTheme.spacing.lg,
                    // Last result clears the system navigation bar (owner bug 2026-07-26).
                    bottom = AppTheme.spacing.lg +
                        WindowInsets.navigationBars.asPaddingValues().calculateBottomPadding(),
                ),
                verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
            ) {
                item {
                    Text(
                        text = stringResource(Res.string.search_result_count, state.results.size),
                        style = AppTheme.typography.labelMd,
                        color = AppTheme.colors.onSurfaceVariant,
                    )
                }
                items(state.results, key = { it.id }) { business ->
                    ResultCard(
                        business = business,
                        favorite = business.id in state.favorites,
                        onBusinessClick = onBusinessClick,
                        onToggleFavorite = onToggleFavorite,
                    )
                }
            }
        }
    }

    if (showFilters) {
        FilterSheet(
            current = state.filters,
            onApply = { onApplyFilters(it); showFilters = false },
            onReset = onResetFilters,
            onDismiss = { showFilters = false },
        )
    }
}

@Composable
private fun FilterButton(activeCount: Int, onClick: () -> Unit) {
    val active = activeCount > 0
    Box(
        modifier = Modifier
            .size(AppTheme.sizes.minTouchTarget)
            .background(
                if (active) AppTheme.colors.primaryContainer else AppTheme.colors.surfaceContainer,
                AppTheme.shapes.pill,
            )
            .clickable(onClick = onClick),
        contentAlignment = Alignment.Center,
    ) {
        AppIcon(
            name = "tune",
            tint = if (active) AppTheme.colors.onPrimary else AppTheme.colors.onSurface,
            contentDescription = stringResource(Res.string.search_filters_a11y),
        )
    }
}

/**
 * What search shows BEFORE the user types: recent (converted) queries and category shortcuts. A
 * blank page under the hero action of Home wasted the screen; this gives two one-tap ways in.
 */
@OptIn(androidx.compose.foundation.layout.ExperimentalLayoutApi::class)
@Composable
private fun PreTypingContent(
    recentSearches: List<String>,
    categories: List<Category>,
    onRecentClick: (String) -> Unit,
    onClearRecents: () -> Unit,
    onCategoryClick: (categoryId: String) -> Unit,
) {
    val lang = AppTheme.language
    Column(
        modifier = Modifier
            .fillMaxSize()
            .verticalScroll(rememberScrollState())
            .padding(AppTheme.spacing.lg),
        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg),
    ) {
        if (recentSearches.isNotEmpty()) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Text(
                    text = stringResource(Res.string.search_recent_title),
                    style = AppTheme.typography.labelMd,
                    color = AppTheme.colors.onSurfaceVariant,
                    modifier = Modifier.weight(1f),
                )
                Text(
                    text = stringResource(Res.string.search_recent_clear),
                    style = AppTheme.typography.labelMd,
                    color = AppTheme.colors.primary,
                    modifier = Modifier
                        .clip(AppTheme.shapes.sm)
                        .clickable(onClick = onClearRecents)
                        .padding(AppTheme.spacing.xs),
                )
            }
            FlowRow(
                horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
            ) {
                recentSearches.forEach { query ->
                    AppChip(label = query, selected = false, onClick = { onRecentClick(query) })
                }
            }
        }
        if (categories.isNotEmpty()) {
            Text(
                text = stringResource(Res.string.search_browse_categories),
                style = AppTheme.typography.labelMd,
                color = AppTheme.colors.onSurfaceVariant,
            )
            FlowRow(
                horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
            ) {
                categories.forEach { category ->
                    AppChip(
                        label = category.displayName(lang),
                        selected = false,
                        onClick = { onCategoryClick(category.id) },
                    )
                }
            }
        }
    }
}

@Composable
private fun EmptyMessage(message: String) {
    Box(
        modifier = Modifier.fillMaxSize().padding(AppTheme.spacing.xxl),
        contentAlignment = Alignment.Center,
    ) {
        Text(
            text = message,
            style = AppTheme.typography.bodyMd,
            color = AppTheme.colors.onSurfaceVariant,
            textAlign = TextAlign.Center,
        )
    }
}

@Composable
private fun ResultCard(
    business: Business,
    favorite: Boolean,
    onBusinessClick: (String) -> Unit,
    onToggleFavorite: (String) -> Unit,
) {
    val lang = AppTheme.language
    val uriHandler = LocalUriHandler.current
    val openStatus = rememberOpenStatus(business)
    val coverUrl = business.coverUrl?.takeIf { it.isNotBlank() }
    val icon = categoryIconKey(business.categoryId)
    val imageRes = categoryImageRes(business.categoryId)
    DirectoryBusinessCard(
        name = business.displayName(lang),
        category = business.serviceLine(lang),
        rating = business.rating.toFloat(),
        openLabel = openStatus?.label,
        isOpen = openStatus?.isOpen ?: true,
        newLabel = stringResource(Res.string.business_badge_new).takeIf { business.reviewCount == 0 },
        // "View menu" only when ordering is actually on for this business — otherwise the CTA is an
        // honest "Details" (QA: the menu label used to show on every card and just opened detail).
        primaryActionLabel = stringResource(
            if (business.offersOrdering) Res.string.business_action_view_menu else Res.string.business_action_details,
        ),
        onPrimaryAction = { onBusinessClick(business.id) },
        onCall = business.phone?.takeIf { it.isNotBlank() }?.let { phone ->
            { uriHandler.openUri("tel:" + phone.filterPhone()) }
        },
        onDirections = business.takeIf { it.showsExactLocation }?.address?.let { address ->
            { uriHandler.openUri(address.mapsUri()) }
        },
        callContentDescription = stringResource(Res.string.business_call_a11y),
        directionsContentDescription = stringResource(Res.string.business_directions_a11y),
        locationLabel = listOf(AppTheme.language.cityLabel(business.address.city), business.address.province)
            .filter { it.isNotBlank() }
            .joinToString(", ")
            .takeIf { it.isNotBlank() },
        verifiedLabel = if (business.verified) stringResource(Res.string.business_verified) else null,
        verifiedContentDescription = stringResource(Res.string.business_verified_a11y),
        sponsoredLabel = if (business.sponsorship.active) stringResource(Res.string.business_sponsored) else null,
        proLabel = if (business.ownerPro) stringResource(Res.string.business_pro_badge) else null,
        favorite = favorite,
        favoriteContentDescription = stringResource(Res.string.business_favorite_a11y),
        onToggleFavorite = { onToggleFavorite(business.id) },
        onClick = { onBusinessClick(business.id) },
        coverIcon = icon,
        coverImageRes = imageRes,
        image = coverUrl?.let { url -> { BusinessCover(imageUrl = url, iconName = icon, placeholderImageRes = imageRes) } },
    )
}

@Composable
private fun FilterSheet(
    current: SearchFilters,
    onApply: (SearchFilters) -> Unit,
    onReset: () -> Unit,
    onDismiss: () -> Unit,
) {
    var draft by remember { mutableStateOf(current) }

    AppBottomSheet(
        onDismissRequest = onDismiss,
        title = stringResource(Res.string.search_sheet_title),
    ) {
        // Sort
        Text(
            text = stringResource(Res.string.search_sort_label),
            style = AppTheme.typography.labelMd,
            color = AppTheme.colors.onSurfaceVariant,
            modifier = Modifier.padding(bottom = AppTheme.spacing.sm),
        )
        Row(
            modifier = Modifier.horizontalScroll(rememberScrollState()),
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        ) {
            SortChip(SearchSort.Recommended, draft.sort, stringResource(Res.string.search_sort_recommended)) { draft = draft.copy(sort = it) }
            SortChip(SearchSort.Nearest, draft.sort, stringResource(Res.string.search_sort_nearest)) { draft = draft.copy(sort = it) }
            SortChip(SearchSort.TopRated, draft.sort, stringResource(Res.string.search_sort_top_rated)) { draft = draft.copy(sort = it) }
            SortChip(SearchSort.MostReviewed, draft.sort, stringResource(Res.string.search_sort_most_reviewed)) { draft = draft.copy(sort = it) }
            SortChip(SearchSort.NameAsc, draft.sort, stringResource(Res.string.search_sort_name)) { draft = draft.copy(sort = it) }
        }

        // Minimum rating
        Text(
            text = stringResource(Res.string.search_rating_label),
            style = AppTheme.typography.labelMd,
            color = AppTheme.colors.onSurfaceVariant,
            modifier = Modifier.padding(top = AppTheme.spacing.lg, bottom = AppTheme.spacing.sm),
        )
        Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
            RatingChip(0, draft.minRating, stringResource(Res.string.search_rating_any)) { draft = draft.copy(minRating = it) }
            RatingChip(3, draft.minRating, stringResource(Res.string.search_rating_3)) { draft = draft.copy(minRating = it) }
            RatingChip(4, draft.minRating, stringResource(Res.string.search_rating_4)) { draft = draft.copy(minRating = it) }
        }

        // Toggles
        Row(
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
            modifier = Modifier.padding(top = AppTheme.spacing.lg),
        ) {
            AppChip(
                label = stringResource(Res.string.search_filter_verified),
                selected = draft.verifiedOnly,
                leadingIcon = "verified",
                onClick = { draft = draft.copy(verifiedOnly = !draft.verifiedOnly) },
            )
            AppChip(
                label = stringResource(Res.string.search_filter_sponsored),
                selected = draft.sponsoredOnly,
                leadingIcon = "star",
                onClick = { draft = draft.copy(sponsoredOnly = !draft.sponsoredOnly) },
            )
        }

        // Amenities — cross-category structured facts ("halal near me").
        Text(
            text = stringResource(Res.string.search_filter_amenities),
            style = AppTheme.typography.labelMd,
            color = AppTheme.colors.onSurfaceVariant,
            modifier = Modifier.padding(top = AppTheme.spacing.lg, bottom = AppTheme.spacing.sm),
        )
        FlowRow(
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        ) {
            BusinessAttributeRegistry.popularFilters.forEach { def ->
                AppChip(
                    label = def.label.resolve(AppTheme.language),
                    selected = def.key in draft.attributes,
                    onClick = {
                        draft = draft.copy(
                            attributes = if (def.key in draft.attributes) draft.attributes - def.key
                            else draft.attributes + def.key,
                        )
                    },
                )
            }
        }

        // Actions
        Row(
            modifier = Modifier.fillMaxWidth().padding(top = AppTheme.spacing.xl),
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        ) {
            AppButton(
                text = stringResource(Res.string.search_reset),
                onClick = { draft = SearchFilters(); onReset() },
                modifier = Modifier.weight(1f),
                variant = AppButtonVariant.Secondary,
            )
            AppButton(
                text = stringResource(Res.string.search_apply),
                onClick = { onApply(draft) },
                modifier = Modifier.weight(1f),
            )
        }
    }
}

@Composable
private fun SortChip(value: SearchSort, selected: SearchSort, label: String, onSelect: (SearchSort) -> Unit) {
    AppChip(label = label, selected = value == selected, onClick = { onSelect(value) })
}

@Composable
private fun RatingChip(value: Int, selected: Int, label: String, onSelect: (Int) -> Unit) {
    AppChip(label = label, selected = value == selected, onClick = { onSelect(value) })
}
